var _style, _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIconAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 629 629",
    style: {
      enableBackground: "new 0 0 629 629"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#015B69;}\n\t.st2{fill:#005058;}\n\t.st3{fill:#00505A;}\n\t.st4{fill:#06958A;}\n\t.st5{fill:#02887E;}\n\t.st6{fill:#007878;}\n\t.st7{fill:#017E7E;}\n\t.st8{fill:#007879;}\n\t.st9{fill:#00797B;}\n\t.st10{fill:#00908F;}\n\t.st11{fill:#008188;}\n\t.st12{fill:#005F62;}\n\t.st13{fill:#00817E;}\n\t.st14{fill:#0097AC;}\n\t.st15{fill:#006969;}\n\t.st16{fill:#018A83;}\n\t.st17{fill:#01A3AD;}\n\t.st18{display:none;fill:#FFFFFF;}\n\t.st19{display:none;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st20{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M504.1,628.9H124.9C56,628.9,0.1,573,0.1,504.1V124.9C0.1,56,56,0.1,124.9,0.1h379.1 C573,0.1,628.9,56,628.9,124.9v379.1C628.9,573,573,628.9,504.1,628.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vTKcx9.tif_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-173.5,-17.1 2.9,199.4 -349.8,199.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-173.5,415.9 -349.8,199.4 2.9,199.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "-173.5,415.9 2.9,632.5 -349.8,632.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2.9,632.5 179.2,415.9 -173.5,415.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "2.9,199.4 -173.5,415.9 179.2,415.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "2.9,199.4 179.2,-17.1 -173.5,-17.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "179.2,415.9 2.9,632.5 355.6,632.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "179.2,415.9 355.6,199.4 2.9,199.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "179.2,-17.1 2.9,199.4 355.6,199.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "355.6,632.5 531.9,415.9 179.2,415.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "355.6,199.4 179.2,415.9 531.9,415.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "355.6,199.4 531.9,-17.1 179.2,-17.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "531.9,415.9 355.6,632.5 708.3,632.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "531.9,415.9 708.3,199.4 355.6,199.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "531.9,-17.1 355.6,199.4 708.3,199.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "708.3,632.5 884.6,415.9 531.9,415.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "708.3,199.4 531.9,415.9 884.6,415.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "708.3,199.4 884.6,-17.1 531.9,-17.1  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M326.5,410.4c7.5,8.3,16.5,15.8,26.3,21.8c20.3,12.8,44.3,18.8,72.1,18.8c26.3-0.8,49.6-6.8,69.9-19.5 c20.3-12,36.1-29.3,47.3-51.1s16.5-46.6,16.5-74.4c0-26.3-5.3-50.3-15.8-72.1c-10.5-21-26.3-38.3-46.6-51.1 C476.8,170,452.7,164,425,164c-165.3,0-103.7,242.7-214.9,242.7c-15.8,0-30.1-3.8-42.1-12s-21-19.5-27.8-34.6 c-6.8-15-9.8-31.6-9.8-51.1c0-19.5,3.8-37.6,11.3-52.6s17.3-27,29.3-35.3s25.5-12,39.8-12c15.8,0,30.1,4.5,42.1,12.8 s21,19.5,27.8,34.6c0.8,2.3,1.5,4.5,2.3,6.8c6.8-20.3,15-40.6,24-59.4c-7.5-7.5-15.8-14.3-24.8-20.3 C261.9,170,237.9,164,210.8,164c-26.3,0.8-49.6,6.8-69.9,19.5c-20.3,12-36.1,29.3-47.3,51.1S77.1,281.2,77.1,309 c0,26.3,5.3,50.3,15.8,72.1c10.5,21,26.3,38.3,46.6,51.1c20.3,12.8,44.3,18.8,72.1,18.8c163-0.8,99.9-242.7,214.1-242.7 c15.8,0,30.1,3.8,42.1,12c12,8.3,21,19.5,27.8,34.6c6.8,15,9.8,31.6,9.8,51.1c0,19.5-3.8,37.6-11.3,52.6s-17.3,27-29.3,35.3 s-25.5,12-39.8,12c-15.8,0-30.1-4.5-42.1-12.8s-21-19.5-27.8-34.6c-1.5-3-3-6.8-3.8-10.5C343.8,369.9,335.5,390.9,326.5,410.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M493.6,463.7H135.4V165.3h358.2V463.7z M478.7,180.2H150.3v268.6h328.3V180.2z M419,374.2v14.9h-59.7 v-14.9H419z M329.4,389.1H165.3l0-13.6c-0.1-15.7-0.1-31.9,25.5-37.8c11.8-2.7,26.2-6,28.2-10.6c0.7-1.6-0.6-4.5-1.5-6.1 c-16.5-30.4-19.5-57.3-8.5-75.8c7.7-12.9,21.6-20.3,38.2-20.3c16.5,0,30.3,7.3,38,20c11,18.3,8.1,45.3-8.2,76 c-0.9,1.6-2.1,4.5-1.4,6.1c2.1,4.6,16.7,7.9,27.3,10.4c26.5,6.1,26.5,22.4,26.4,38.2L329.4,389.1z M180.2,374.2h134.3 c0-15.1-0.8-19-14-22c-17.5-4-33.2-7.7-38.4-18.9c-2.6-5.7-2-12.2,1.8-19.3c13.7-26,16.8-47.7,8.6-61.3 c-5-8.2-13.9-12.8-25.2-12.8c-11.4,0-20.4,4.6-25.4,13c-8.1,13.6-4.9,35.8,8.8,61c3.9,7.1,4.5,13.6,1.9,19.3 c-5.1,11.3-20.7,14.9-37.2,18.7C181,355.2,180.2,359.1,180.2,374.2z M448.8,329.4v14.9h-89.5v-14.9H448.8z M448.8,284.7v14.9 h-89.5v-14.9H448.8z M448.8,239.9v14.9h-89.5v-14.9H448.8z"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M347.3,410.1v9.3H117.5v-9.6c-0.1-25.6,1-40.2,30.4-46.9c32.2-7.4,64-14.1,48.8-42.3 c-45.3-83.6-12.9-131,35.7-131c47.7,0,80.9,45.6,35.8,131c-14.9,28,15.8,34.7,48.8,42.3C346.4,369.7,347.4,384.4,347.3,410.1z  M511.5,189.6H380.2v32.8h131.3V189.6z M511.5,255.3H380.2v32.8h131.3V255.3z M511.5,320.9H380.2v32.8h131.3V320.9z M511.5,386.6 H380.2v32.8h131.3V386.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconAdmin);
export default __webpack_public_path__ + "static/media/app_icon_admin.5344abb171d1144698008db625e02339.svg";
export { ForwardRef as ReactComponent };